import { Application } from "@hotwired/stimulus";

const application = Application.start();

import AnimatedCursorController from "./controllers/2021/animated-cursor_controller";
application.register("animated-cursor", AnimatedCursorController);

import AnimatedHeadingController from "./controllers/2021/animated-heading_controller";
application.register("animated-heading", AnimatedHeadingController);

import AnimatedSealController from "./controllers/2021/animated-seal_controller";
application.register("animated-seal", AnimatedSealController);

import ImageFlipController from "./controllers/2021/image-flip_controller";
application.register("image-flip", ImageFlipController);

import OffCanvasController from "./controllers/offcanvas_controller";
application.register("offcanvas", OffCanvasController);

import ShareController from "./controllers/2021/share_controller";
application.register("share", ShareController);

import VideoController from "./controllers/2021/video_controller";
application.register("video", VideoController);